const passwordConstants={
   
    POST_FORGOTPWD_REQUEST:"POST_FORGOTPWD_REQUEST",
    POST_FORGOTPWD_SUCCESS:"POST_FORGOTPWD_SUCCESS",
    POST_FORGOTPWD_FAILURE:"POST_FORGOTPWD_FAILURE",   
    
}

export {passwordConstants}